import { createPinia } from 'pinia'

// 导出供vue注册
const pinia = createPinia()
export default pinia
export  { default as useUserInfoStore } from './modules/userInfo'
